<template>
    <div class="modal-image full-width" @click="close">
        <img :src="image" />
    </div>
</template>


<script>

export default {
    methods: {
        close: function() {
            this.$emit('close')
        }
    },
    computed: {
        image: function() {
            return this.$store.state.images.current
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .modal-content.modal-image {

        img {
            max-width: 100%;
            margin: 3em auto;
            width: auto;
        }
    }

</style>



// WEBPACK FOOTER //
// Image.vue?9743d284